import { render } from "./aiSetup.vue?vue&type=template&id=1ed7fae4"
import script from "./aiSetup.vue?vue&type=script&lang=js"
export * from "./aiSetup.vue?vue&type=script&lang=js"

import "./aiSetup.vue?vue&type=style&index=0&id=1ed7fae4&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__